import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <footer
      style={{
        background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
        color: "#f1f1f1",
      }}
      className="pt-5 pb-4"
      data-aos="fade-up"
    >
      <div className="container">
        <div className="row g-5 footer-main-content">
          {/* Company Info */}
          <div className="col-lg-4 col-md-6 text-center text-md-start">
            <Link to="/" className="text-decoration-none">
              <h2 className="fw-bold highlight-blue">
                Varay <span className="text-white">QC Services</span>
              </h2>
            </Link>
            <p className="mt-3">
              At Varay QC Services, we ensure every product meets global
              standards through expert sourcing, inspection, and precision-based
              quality control — your quality, our priority.
            </p>
            <div className="d-flex justify-content-center justify-content-md-start gap-3 mt-3">
              <a
                href="https://www.instagram.com/varay_qc_services/"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Instagram"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  size="2x"
                  className="footer-icon"
                  aria-hidden="true"
                />
              </a>
              <a
                href="tel:+919016972420"
                className="text-light"
                aria-label="Call us"
              >
                <FontAwesomeIcon
                  icon={faHeadset}
                  size="2x"
                  className="footer-icon"
                  aria-hidden="true"
                />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6 d-flex flex-column align-items-center text-center">
            <h5 className="fw-bold highlight-blue">Quick Links</h5>
            <ul className="list-unstyled mt-3">
              <li>
                <Link
                  to="/about"
                  className="text-light text-decoration-none footer-link"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-light text-decoration-none footer-link"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-4 col-md-6 text-center text-md-end">
            <h5 className="fw-bold highlight-blue">Contact Us</h5>
            <ul className="list-unstyled mt-3">
              <li className="mb-2">
                <a
                  href="tel:+919016972420"
                  className="text-light text-decoration-none footer-link py-2 border-bottom border-primary d-inline-block"
                  aria-label="Call us on phone"
                >
                  <FontAwesomeIcon
                    icon={faPhone}
                    className="me-2 highlight-blue"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                  +91 90169 72420
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="mailto:quality@varayqcservices.com"
                  className="text-light text-decoration-none footer-link py-2 border-bottom border-primary d-inline-block"
                  aria-label="Send us an email"
                >
                  <FaEnvelope
                    className="me-2 highlight-blue"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                  quality@varayqcservices.com{" "}
                </a>
              </li>
               <li className="mb-2">
                <a
                  href="mailto:varayqaservices@gmail.com"
                  className="text-light text-decoration-none footer-link py-2 border-bottom border-primary d-inline-block"
                  aria-label="Send us an email"
                >
                  <FaEnvelope
                    className="me-2 highlight-blue"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                  varayqaservices@gmail.com {" "}
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/919016972420?text=Hello,%20I%20need%20assistance."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light text-decoration-none footer-link py-2 border-bottom border-primary d-inline-block"
                  aria-label="Chat on WhatsApp"
                >
                  <FaWhatsapp
                    className="me-2 highlight-blue"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                  Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="text-light mt-5 mb-4" />

        <div className="text-center text-light" style={{ fontSize: "1.2rem" }}>
          <p className="mb-0">
            Copyright ©️ 2025,{" "}
            <span style={{ color: "#00d9ff" }}>Varay QC Services</span>. All
            rights reserved.
          </p>
          <p>
            Designed & Developed by{" "}
            <span style={{ color: "#00d9ff" }}>Dharmik Sinojiya</span>. All
            assets including images belong to their respective owners.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
